import { encodeQueryItem } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'
import { createOperationsGenerator } from '#image'

const operationsGenerator = createOperationsGenerator({
    keyMap: {
        width: 'w',
        height: 'h',
        dpr: 'dpr',
        fit: 'fit',
        quality: 'q',
        format: 'fm',
        background: 'bg',
    },
    valueMap: {
        fit: {
            contain: 'clip',
            outside: 'crop',
        },
    },
    joinWith: '&',
    formatter: (key: string, val: string) => encodeQueryItem(key, val),
});

const defaultModifiers = {format: 'auto'}

// https://developers.cloudflare.com/images/image-resizing/url-format/
export const getImage: ProviderGetImage = (src, {
  modifiers = {},
} = {}) => {
  const mergeModifiers = { ...defaultModifiers, ...modifiers }
  const operations = operationsGenerator(mergeModifiers as any);
  // console.log('kentico operations', operations, mergeModifiers);
  // https://<ZONE>/cdn-cgi/image/<OPTIONS>/<SOURCE-IMAGE>
  const url = operations ? `${src}?${operations}` : src
  // console.log('final url', url);
  return {
    url
  }
}